import { useEffect } from 'react';

/** Elimina la barra inferior antigua si un bundle cacheado aún la monta. */
export default function LegacyBottomNavCleanup() {
    useEffect(() => {
        function removeLegacyNav() {
            document.querySelectorAll('.layout nav.layout-nav:not(.layout-nav-supervisor)').forEach((el) => {
                el.remove();
            });
        }

        removeLegacyNav();
        const observer = new MutationObserver(removeLegacyNav);
        const root = document.getElementById('root');
        if (root) {
            observer.observe(root, { childList: true, subtree: true });
        }
        return () => observer.disconnect();
    }, []);

    return null;
}
